import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/bomb.svg'


const _withScopeId = n => (_pushScopeId("data-v-141227be"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gradientOverlay" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_3 = { class: "fev_text1 fw_800 question" }
const _hoisted_4 = { class: "answers_div" }
const _hoisted_5 = { class: "fev_button mb-3 box_shadow" }
const _hoisted_6 = { class: "flex_centered mt-3" }
const _hoisted_7 = {
  key: 0,
  class: "bomb",
  src: _imports_0
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "imageCardContainer bg_blue mb-4",
      style: _normalizeStyle('background-image: url(\'' + _ctx.profileQuestion.image + '\')')
    }, [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.profileQuestion.question), 1)
    ], 4),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profileQuestion.answers, (answer, index) => {
        return (_openBlock(), _createElementBlock("button", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(answer.answer), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(answer.percentage) + " %", 1),
            (_ctx.profileQuestion.minPercentage && _ctx.profileQuestion.minPercentage > answer.percentage)
              ? (_openBlock(), _createElementBlock("img", _hoisted_7))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 256))
    ])
  ], 64))
}